<template>
  <multiselect
    v-model="selecionado"
    :options="options"
    :disabled="disabled"
    v-bind="atributos"
    @input="onInput"
    @select="onSelect"
  />
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "MultiSelect",
  components: {
    Multiselect
  },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data,
  methods: {
    onInput,
    onSelect
  },
  watch: {
    value
  },
  computed: {
    atributos
  }
};

function data() {
  return {
    selecionado: this.value
  };
}

function onInput() {
  this.$emit("input", this.selecionado);
  this.$emit("change", this.selecionado);
}

function onSelect(value) {
  this.$emit("select", value);
}

function value() {
  this.selecionado = this.value;
}

function atributos() {
  const atributos = Object.assign({}, this.$attrs);

  if (atributos["hideSelected"] == null) {
    atributos.hideSelected = true;
  }

  if (atributos["closeOnSelect"] == null) {
    atributos.closeOnSelect = false;
  }

  if (atributos["placeholder"] == null) {
    atributos.placeholder = "Selecione";
  }

  if (atributos["selectLabel"] == null) {
    atributos.selectLabel = "";
  }

  if (atributos["selectGroupLabel"] == null) {
    atributos.selectGroupLabel = "Pressione enter para selecionar o grupo";
  }

  if (atributos["deselectGroupLabel"] == null) {
    atributos.deselectGroupLabel = "Pressione enter para desmarcar o grupo";
  }

  atributos.multiple = true;

  return atributos;
}
</script>
